export const BULK_MANAGE_NOTIFICATIONS_KEY = 'BULK_MANAGE_NOTIFICATIONS';
export const BULK_MANAGE_NOTIFICATIONS_URL =
  '/api/v2/hosts/bulk/manage_notifications';
